import utils from '@eitje/utils'
import {useHotkeys} from 'react-hotkeys-hook'
import {SubmitButton} from '~/components/eitje_button'
import {useFormSubmitButtonProps} from '../../hooks'

export const FormSubmitButton = ({ref, popoutTitle, className, disabled, dropdown, iconLeft, ...otherButtonProps}) => {
	const {onSubmit, isMissingRequiredFields} = useFormSubmitButtonProps()

	// Only works when current focus is not in any form fields
	useHotkeys('mod+enter', onSubmit, {enabled: !disabled && Boolean(onSubmit)})

	return (
		<SubmitButton
			className={utils.makeCns('form-submit-button', className)}
			isGreyedOut={isMissingRequiredFields}
			popoutTitle={isMissingRequiredFields ? 'form.general.tooltips.missing_required_fields' : popoutTitle}
			ref={ref}
			onClick={onSubmit}
			disabled={disabled}
			iconLeft={iconLeft}
			dropdown={dropdown}
			{...otherButtonProps}
		/>
	)
}
